import Box from '@mui/material/Box'
import { BoxProps } from '@mui/material/Box'

export const PageItemContent = (props: BoxProps) => {
  return <Box p={4} {...props} />
}
